import type { AddOnsVO } from './add-ons';
import { getStartingPriceFromAddOn, hasPriceTiers } from './get-addon-starting-price';

/**
 * Resolves Inbox Preview "starting at" price from a geo-based getAddOns response (premium-plan anchor).
 * Matches `inboxPreviewAddOnId` (country-config) and reads the lowest-tier starting price.
 * Returns null only when addOns is null/undefined (loading/error) or the addon has no tiers.
 */
export function getInboxPreviewStartingPriceFromAddOns(
  addOns: AddOnsVO | undefined | null,
  inboxPreviewAddOnId: string
): number | null {
  if (!addOns) {
    return null;
  }

  const inboxPreviewAddOn = addOns.getAddOns().find((addOn) => addOn.getId() === inboxPreviewAddOnId);

  if (!hasPriceTiers(inboxPreviewAddOn)) {
    return null;
  }

  const startingPrice = getStartingPriceFromAddOn(inboxPreviewAddOn);

  return startingPrice > 0 ? startingPrice : null;
}
